unit View.Grade_Colunas.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UUtils;

type
  TFViewGrade_ColunasList = class(TForm)
    btNew: TButton;
    Grade_ColunasDataset: TXDataWebDataSet;
    Grade_ColunasDatasetid: TIntegerField;
    Grade_ColunasDatasetaliado_id: TIntegerField;
    Grade_ColunasDatasetdata_base_id: TIntegerField;
    Grade_ColunasDatasetgrade_descricoes_id: TIntegerField;
    Grade_ColunasDatasetnome: TStringField;
    Grade_ColunasDatasetcadastro: TDateTimeField;
    Grade_ColunasDatasetcodigo_interno: TIntegerField;
    Grade_ColunasDatasetexcluido: TBooleanField;
    Grade_ColunasDatasetinclusao: TDateTimeField;
    Grade_ColunasDatasetalteracao: TDateTimeField;
    Grade_ColunasDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure edSearchChange(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewGrade_ColunasList: TFViewGrade_ColunasList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewGrade_ColunasList }

procedure TFViewGrade_ColunasList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewGrade_ColunasList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewGrade_ColunasList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewGrade_ColunasList, AElementID, Result, @AfterCreate);
end;

procedure TFViewGrade_ColunasList.edSearchChange(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewGrade_ColunasList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewGrade_ColunasList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      Grade_ColunasDataset.Connection.Model.DefaultSchema.FindEntityType(Grade_ColunasDataset.EntitySetName),
      Grade_ColunasDataset.CurrentData
    );
    Button := TButton.Create(nil);
    Button.Caption := 'Edit';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-outline btn-default btn-xs';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
  end;
end;

procedure TFViewGrade_ColunasList.WebFormCreate(Sender: TObject);
begin
  TUtils.SetValorDicionarioClasses('grade_colunas', 'active');
  TUtils.SetValorDicionarioClasses('produtos_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_produtos', 'active');
  TUtils.SetValorDicionarioClasses('grades_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_grades', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    Grade_ColunasDataset,
    lcPaginator,
    lbPaginationInfo
  );
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewGrade_ColunasList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.grade_colunas.list.pagination.info');
  btNew := TButton.Create('view.grade_colunas.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.grade_colunas.list.table');
  cbPageSize := TComboBox.Create('view.grade_colunas.list.cbPageSize');
  edSearch := TEdit.Create('view.grade_colunas.list.search');
  lcPaginator := TListControl.Create('view.grade_colunas.list.pagination');
  Grade_ColunasDataset := TXDataWebDataSet.Create(Self);
  Grade_ColunasDatasetid := TIntegerField.Create(Self);
  Grade_ColunasDatasetaliado_id := TIntegerField.Create(Self);
  Grade_ColunasDatasetdata_base_id := TIntegerField.Create(Self);
  Grade_ColunasDatasetgrade_descricoes_id := TIntegerField.Create(Self);
  Grade_ColunasDatasetnome := TStringField.Create(Self);
  Grade_ColunasDatasetcadastro := TDateTimeField.Create(Self);
  Grade_ColunasDatasetcodigo_interno := TIntegerField.Create(Self);
  Grade_ColunasDatasetexcluido := TBooleanField.Create(Self);
  Grade_ColunasDatasetinclusao := TDateTimeField.Create(Self);
  Grade_ColunasDatasetalteracao := TDateTimeField.Create(Self);
  Grade_ColunasDatasetexclusao := TDateTimeField.Create(Self);
  WebDataSource := TDataSource.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  Grade_ColunasDataset.BeforeLoadDFMValues;
  Grade_ColunasDatasetid.BeforeLoadDFMValues;
  Grade_ColunasDatasetaliado_id.BeforeLoadDFMValues;
  Grade_ColunasDatasetdata_base_id.BeforeLoadDFMValues;
  Grade_ColunasDatasetgrade_descricoes_id.BeforeLoadDFMValues;
  Grade_ColunasDatasetnome.BeforeLoadDFMValues;
  Grade_ColunasDatasetcadastro.BeforeLoadDFMValues;
  Grade_ColunasDatasetcodigo_interno.BeforeLoadDFMValues;
  Grade_ColunasDatasetexcluido.BeforeLoadDFMValues;
  Grade_ColunasDatasetinclusao.BeforeLoadDFMValues;
  Grade_ColunasDatasetalteracao.BeforeLoadDFMValues;
  Grade_ColunasDatasetexclusao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  try
    Name := 'FViewGrade_ColunasList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'New';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'id';
      Title := 'id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliado_id';
      Title := 'aliado_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_base_id';
      Title := 'data_base_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'grade_descricoes_id';
      Title := 'grade_descricoes_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nome';
      Title := 'nome';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cadastro';
      Title := 'cadastro';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_interno';
      Title := 'codigo_interno';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'excluido';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'inclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'alteracao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'exclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'Actions';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnChange', 'edSearchChange');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    Grade_ColunasDataset.SetParentComponent(Self);
    Grade_ColunasDataset.Name := 'Grade_ColunasDataset';
    Grade_ColunasDataset.EntitySetName := 'Grade_Colunas';
    Grade_ColunasDataset.Connection := DMConnection.ApiConnection;
    Grade_ColunasDataset.Left := 72;
    Grade_ColunasDataset.Top := 144;
    Grade_ColunasDatasetid.SetParentComponent(Grade_ColunasDataset);
    Grade_ColunasDatasetid.Name := 'Grade_ColunasDatasetid';
    Grade_ColunasDatasetid.FieldName := 'id';
    Grade_ColunasDatasetid.Required := True;
    Grade_ColunasDatasetaliado_id.SetParentComponent(Grade_ColunasDataset);
    Grade_ColunasDatasetaliado_id.Name := 'Grade_ColunasDatasetaliado_id';
    Grade_ColunasDatasetaliado_id.FieldName := 'aliado_id';
    Grade_ColunasDatasetaliado_id.Required := True;
    Grade_ColunasDatasetdata_base_id.SetParentComponent(Grade_ColunasDataset);
    Grade_ColunasDatasetdata_base_id.Name := 'Grade_ColunasDatasetdata_base_id';
    Grade_ColunasDatasetdata_base_id.FieldName := 'data_base_id';
    Grade_ColunasDatasetdata_base_id.Required := True;
    Grade_ColunasDatasetgrade_descricoes_id.SetParentComponent(Grade_ColunasDataset);
    Grade_ColunasDatasetgrade_descricoes_id.Name := 'Grade_ColunasDatasetgrade_descricoes_id';
    Grade_ColunasDatasetgrade_descricoes_id.FieldName := 'grade_descricoes_id';
    Grade_ColunasDatasetgrade_descricoes_id.Required := True;
    Grade_ColunasDatasetnome.SetParentComponent(Grade_ColunasDataset);
    Grade_ColunasDatasetnome.Name := 'Grade_ColunasDatasetnome';
    Grade_ColunasDatasetnome.FieldName := 'nome';
    Grade_ColunasDatasetnome.Required := True;
    Grade_ColunasDatasetnome.Size := 255;
    Grade_ColunasDatasetcadastro.SetParentComponent(Grade_ColunasDataset);
    Grade_ColunasDatasetcadastro.Name := 'Grade_ColunasDatasetcadastro';
    Grade_ColunasDatasetcadastro.FieldName := 'cadastro';
    Grade_ColunasDatasetcodigo_interno.SetParentComponent(Grade_ColunasDataset);
    Grade_ColunasDatasetcodigo_interno.Name := 'Grade_ColunasDatasetcodigo_interno';
    Grade_ColunasDatasetcodigo_interno.FieldName := 'codigo_interno';
    Grade_ColunasDatasetcodigo_interno.Required := True;
    Grade_ColunasDatasetexcluido.SetParentComponent(Grade_ColunasDataset);
    Grade_ColunasDatasetexcluido.Name := 'Grade_ColunasDatasetexcluido';
    Grade_ColunasDatasetexcluido.FieldName := 'excluido';
    Grade_ColunasDatasetinclusao.SetParentComponent(Grade_ColunasDataset);
    Grade_ColunasDatasetinclusao.Name := 'Grade_ColunasDatasetinclusao';
    Grade_ColunasDatasetinclusao.FieldName := 'inclusao';
    Grade_ColunasDatasetalteracao.SetParentComponent(Grade_ColunasDataset);
    Grade_ColunasDatasetalteracao.Name := 'Grade_ColunasDatasetalteracao';
    Grade_ColunasDatasetalteracao.FieldName := 'alteracao';
    Grade_ColunasDatasetexclusao.SetParentComponent(Grade_ColunasDataset);
    Grade_ColunasDatasetexclusao.Name := 'Grade_ColunasDatasetexclusao';
    Grade_ColunasDatasetexclusao.FieldName := 'exclusao';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := Grade_ColunasDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    Grade_ColunasDataset.AfterLoadDFMValues;
    Grade_ColunasDatasetid.AfterLoadDFMValues;
    Grade_ColunasDatasetaliado_id.AfterLoadDFMValues;
    Grade_ColunasDatasetdata_base_id.AfterLoadDFMValues;
    Grade_ColunasDatasetgrade_descricoes_id.AfterLoadDFMValues;
    Grade_ColunasDatasetnome.AfterLoadDFMValues;
    Grade_ColunasDatasetcadastro.AfterLoadDFMValues;
    Grade_ColunasDatasetcodigo_interno.AfterLoadDFMValues;
    Grade_ColunasDatasetexcluido.AfterLoadDFMValues;
    Grade_ColunasDatasetinclusao.AfterLoadDFMValues;
    Grade_ColunasDatasetalteracao.AfterLoadDFMValues;
    Grade_ColunasDatasetexclusao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
  end;
end;

end.
